// TODO: implement user page wrapper
export default function UserPage() {
  return <div>User Page</div>
}
